module.exports = __webpack_public_path__ + "static/leseprobe2_uschtrin_kap01-3a4b6a5615e83d642514de5f99b21a21.pdf";